module.exports = __webpack_public_path__ + "media/components/Pages/AdoptionEvening/bookevening-d0e2203363efd616d2c7a37671d678dd.jpg";